/**
 * @desc 作废tms单号
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.transportMaster.cancelTms.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/cancelTms`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
